export type ZoomBand = "city" | "street";

// Tunable: individual (de-clustered) markers show as photo pins below the
// threshold and shrink to category dots at/above it. Mobile crowds faster, so
// it trips one zoom level earlier.
export const STREET_ZOOM_DESKTOP = 16;
export const STREET_ZOOM_MOBILE = 15;

export function zoomBand(zoom: number, isMobile = false): ZoomBand {
  const threshold = isMobile ? STREET_ZOOM_MOBILE : STREET_ZOOM_DESKTOP;
  return zoom >= threshold ? "street" : "city";
}
